import { render, staticRenderFns } from "./ClientsTable.vue?vue&type=template&id=bc36248c&scoped=true&"
import script from "./ClientsTable.vue?vue&type=script&lang=js&"
export * from "./ClientsTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientsTable.vue?vue&type=style&index=0&id=bc36248c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc36248c",
  null
  
)

export default component.exports